export const aboutPageData = {
  seoText: 'Joy - Wedding Planning, Redesigned',

  seo: {
    title: 'Wedding App | Wedding AboutUs | Joy',
    content:
      'The best wedding app for you and your guests. Keep track of wedding details on the go, collect and share photos, make announcements, and more.',
  },
  heroSection: {
    title: 'Inspired by love, created with Joy.',
  },
  ourStory: {
    title: 'Our Story',
    stories: [
      'Michael, Kaiwalya, and I founded Joy to make wedding planning more intuitive, thoughtful, and personal.',
      'It all started when Michael’s sister Amy was planning her wedding and we saw her struggle to find a wedding website that offered the personalization and attention to detail she was looking for. We built her a custom website to fit her style, and when her friends and wedding guests began asking us to create sites for them, we knew we were on to something.',
      'Soon we were meeting after our day jobs, spending our spare time designing a website that anyone could customize to feel like it was built just for them. In 2016 we officially founded Joy.',
      'We started with beautiful wedding websites, then developed powerful tools to modernize wedding planning, help couples stay organized, and create a seamless experience for couples and their guests.',
      'We’re constantly evolving and building new features, to give you a smarter way to plan your big day.',
    ],
    sincerely: 'Sincerely,',
    storyPerson: 'Vishal Joshi',
    designation: 'Co-founder and CEO',
  },
  diversity: {
    title: 'Diversity & Inclusion Pledge',
    body:
      'Diversity, inclusion, and equity are part of Joy’s mission, vision, and DNA. We celebrate love in all its forms. We do not tolerate discrimination of any kind.',
    pledgeContent:
      'We vow to support and celebrate diverse couples, wedding planners and wedding vendors.We are taking action as a company to create lasting change and to do our part to ensure hate and discrimination have no place in this world or within the wedding industry.',
    readMoreContent: {
      heading: 'Joy’s Diversity & Inclusion Commitments',
      readMoreParagraphs: [
        {
          title: 'Our promise to the Joy community',
          bodyList: [
            'We will highlight diverse couples and vendors across our content, and partner with diverse influencers, creators, and writers.',
            'We will ensure our influencer and blog partners uphold our company values.',
          ],
        },
        {
          title: 'Our vow to the wedding industry',
          bodyList: [
            'We will highlight diverse wedding vendors, and discontinue partnerships with any vendors that express racist or prejudicial behavior.',
            'We will partner with diverse businesses, artists, and designers, and advertise with diverse publications.',
            'As attendees or speakers, we will only attend events and conferences that uphold our company values.',
            'We will ensure our vendor list for styled shoots and events is diverse.',
          ],
        },
        {
          title: 'Our commitments as a company',
          bodyList: [
            'We will hire diverse employees to ensure people of all colors, backgrounds, and mindsets are represented within Joy.',
            'We will educate all team members on what it means to be an ally, and our team will receive diversity & inclusion and unconscious bias trainings.',
            'Our zero-tolerance policy for racism and discrimination will be upheld across our team, our partners, and any wedding vendors or industry members we feature in our content.',
            'Joy prohibits discrimination based on race, color, religion, sex, national origin, ancestry, disability, marital, family, pregnancy status, sexual orientation, gender identity, gender expression, veteran or citizenship status.',
          ],
        },
      ],
    },
    readMore: 'Read More',
    readLess: 'Read Less',
    exploreCareers: 'Explore Careers',
    joinUsTitle: 'Join Us',
    joinUsBody:
      'We’re always searching for qualified candidates to join our team! You will be a key player in an early stage startup and your talent and passion will help us build a great product and company. View our open job positions, or drop us a line at <a id="explore_email_link" target="_blank" href="mailto:hello@withjoy.com">hello@withjoy.com</a> for more information.',
  },
  featuredData: {
    title: 'As Featured In',
  },
  emotionalSection: {
    title: 'A grand statement about our values?',
  },
  photoCollectionData: {
    title:
      'Joy offers beautiful, customizable wedding websites and intuitive planning tools, giving you everything you need to stay organized as you plan your wedding.',
    altText: 'Joy Photo Collections',
  },
  footerHero: { footerHeroTitle: 'We’re building a better way to plan weddings.' },
} as const;
